export const handleToggleVisibility = (elements, state = 'hide') => {
  if(typeof(elements) != 'undefined') {
    if(state === 'hide') {
      elements.forEach(e=> {
        e.classList.add('hidden')
      })
    } else {
      elements.forEach(e=> {
        e.classList.remove('hidden')
      })
    }
  }
}
